module.exports = __webpack_public_path__ + "statics/img/bannner1.e52a71c2.jpg";